import React from "react";

import { FileLists } from "..";
import {  EmptyFolder } from "../../assets/images";




const EcoFiles: React.FC = () => {

  const [files, setFiles] = React.useState<any[]>([]);

  return (
    <div className="w-full flex pt-2 flex-col items-center gap-7">
      {files ? <FileLists/> : 
        <div className="flex flex-col pt-8 bg-none">
          <img src={EmptyFolder} alt="" />
          <h1 className=" font-Inter text-lg text-TransGrey ">
            No files found
          </h1>
        </div>
      }
    </div>
  );
};

export default EcoFiles;
